// src/firebase/config.js
import { initializeApp } from "https://www.gstatic.com/firebasejs/11.3.1/firebase-app.js";
import { getFirestore } from "https://www.gstatic.com/firebasejs/11.3.1/firebase-firestore.js";
import { getAuth } from "https://www.gstatic.com/firebasejs/11.3.1/firebase-auth.js";
import { getStorage } from "https://www.gstatic.com/firebasejs/11.3.1/firebase-storage.js";

// Your web app's Firebase configuration
// Replace these values with your actual Firebase project credentials
const firebaseConfig = {
  apiKey: "AIzaSyAOx7QERnfr0bwa_t1pgcNORyWlDWDiCq8",
  authDomain: "hussain-sons.firebaseapp.com",
  projectId: "hussain-sons",
  storageBucket: "hussain-sons.firebasestorage.app",
  messagingSenderId: "47598393768",
  appId: "1:47598393768:web:978d05c4d9599eb34de59d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
